import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Constants from "../../constants";

const initialState = {
    languageListLoader: false,
    languageCollection: {},
    workflowLoader: false,
}

export const SystemLanguageListJSON = createAsyncThunk(
    'system/SystemLanguageListJSON', async(credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'LanguageListJSON?Token='+credentials.token+'&LANGUAGE='+credentials.language+'&CODE='+credentials.code+'&Pronoun=undefined', {
                method: 'get'
            })
            const data = await response.json();
            return data
        } catch (err) {

        }
    }
)

export const SystemAddUpdateLanguageJSON = createAsyncThunk(
    'system/SystemAddUpdateLanguageJSON', async(credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'AddUpdateLanguageJSON?Token='+credentials.token+'&LANGUAGE='+credentials.language+'&CODE='+credentials.code+'&TEXTSTRING='+credentials.textString, {
                method: 'get',
            })
            const data = await response.json();
            return data;
        } catch (err) {

        }
    }
)

export const SystemWorkflowDefinitionJSON = createAsyncThunk(
    'system/SystemWorkflowDefinitionJSON', async(credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'WorkflowDefinitionJSON?Token='+credentials.token+'&WorkflowID='+credentials.workflowId, {
                method: 'get',
            })
            const data = await response.json();
            return data;
        } catch (err) {

        }
    }
)

export const SystemWorkflowAddUpdateDefinitionJSON = createAsyncThunk(
    'system/SystemWorkflowAddUpdateDefinitionJSON', async(credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'AddUpdateWorkflowJSON?Token='+credentials.token+'&WorkflowID='+credentials.workflowId+'&Title='+credentials.title+'&Description='+credentials.description+'&Type='+credentials.type+'&HelpText='+credentials.helpText+'&Active='+credentials.active, {
                method: 'get',
            })
            const data = await response.json();
            return data;
        } catch (err) {

        }
    }
)

export const SystemWorkflowControlsJSON = createAsyncThunk(
    'system/SystemWorkflowControlsJSON', async(credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'WorkflowControlsJSON?Token='+credentials.token+'&WorkflowID='+credentials.workflowId+'&SectionID='+credentials.sectionId+'&StepID='+credentials.stepId+'&ControlID='+credentials.controlId, {
                method: 'get',
            })
            const data = await response.json();
            return data;
        } catch (err) {

        }
    }
)

export const SystemWorkflowAddUpdateControlsJSON = createAsyncThunk(
    'system/SystemWorkflowAddUpdateControlsJSON', async(credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'AddUpdateWorkflowControlsJSON?Token='+credentials.token+'&WorkflowID='+credentials.workflowId+'&StepID='+credentials.stepId+'&SectionID='+credentials.sectionId+'&ControlID='+credentials.controlId+'&OrderID='+credentials.orderId+'&Title='+credentials.title+'&Description='+credentials.description+'&Type='+credentials.type+'&Row='+credentials.row+'&Col='+credentials.row+'&DefaultValue='+credentials.row+'&Action='+credentials.action+'&Validation='+credentials.validation+'&HelpText='+credentials.helpText+'&Active='+credentials.active, {
                method: 'get',
            })
            const data = await response.json();
            return data;
        } catch (err) {

        }
    }
)

export const SystemWorkflowSectionsJSON = createAsyncThunk(
    'system/SystemWorkflowSectionsJSON', async(credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'WorkflowSectionsJSON?Token='+credentials.token+'&WorkflowID='+credentials.workflowId+'&StepID='+credentials.stepId+'&SectionID=%', {
                method: 'get',
            })
            const data = await response.json();
            return data;
        } catch (err) {

        }
    }
)

export const SystemWorkflowAddUpdateSectionsJSON = createAsyncThunk(
    'system/SystemWorkflowAddUpdateSectionsJSON', async(credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'AddUpdateWorkflowSectionsJSON?Token='+credentials.token+'&WorkflowID='+credentials.workflowId+'&StepID='+credentials.stepId+'&SectionID='+credentials.sectionId+'&OrderID='+credentials.orderId+'&Title='+credentials.title+'&Description='+credentials.description+'&Type='+credentials.type+'&HelpText='+credentials.helpText+'&Active='+credentials.active+'&VAlignment='+credentials.vAlignment+'&HAlignment='+credentials.hAlignment, {
                method: 'get',
            })
            const data = await response.json();
            return data;
        } catch (err) {

        }
    }
)

export const SystemWorkflowStepsJSON = createAsyncThunk(
    'system/SystemWorkflowStepsJSON', async(credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'WorkflowStepsJSON?Token='+credentials.token+'&WorkflowID='+credentials.workflowId+'&SectionID='+credentials.sectionId+'&StepID='+credentials.stepId, {
                method: 'get',
            })
            const data = await response.json();
            return data;
        } catch (err) {

        }
    }
)

export const SystemWorkflowAddUpdateStepsJSON = createAsyncThunk(
    'system/SystemWorkflowAddUpdateStepsJSON', async(credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+'AddUpdateWorkflowStepsJSON?Token='+credentials.token+'&WorkflowID='+credentials.workflowId+'&StepID='+credentials.stepId+'&OrderID='+credentials.orderId+'&Title='+credentials.title+'&Description='+credentials.description+'&Type='+credentials.type+'&HelpText='+credentials.helpText+'&Active='+credentials.active, {
                method: 'get',
            })
            const data = await response.json();
            return data;
        } catch (err) {

        }
    }
)

export const AdminSystemSlice = createSlice({
    name: 'AdminSystemSlice',
    initialState,
    reducers: {
        setLanguageCollection: (state, action) => {
            window.lt = {...action.payload};
            state.languageCollection = {...action.payload}
        },
    },
    extraReducers: {
        [SystemLanguageListJSON.pending]: (state, action) => {
            state.languageListLoader = true
        },
        [SystemLanguageListJSON.fulfilled]: (state, action) => {
            state.languageListLoader = false
        },
        [SystemLanguageListJSON.rejected]: (state, action) => {
            state.languageListLoader = false
        },

        [SystemAddUpdateLanguageJSON.pending]: (state, action) => {

        },
        [SystemAddUpdateLanguageJSON.fulfilled]: (state, action) => {

        },
        [SystemAddUpdateLanguageJSON.rejected]: (state, action) => {
            
        },

        [SystemWorkflowDefinitionJSON.pending]: (state, action) => {
            state.workflowLoader = true;
        },
        [SystemWorkflowDefinitionJSON.fulfilled]: (state, action) => {
            state.workflowLoader = false;
        },
        [SystemWorkflowDefinitionJSON.rejected]: (state, action) => {
            state.workflowLoader = false;
        },

        [SystemWorkflowAddUpdateDefinitionJSON.pending]: (state, action) => {

        },
        [SystemWorkflowAddUpdateDefinitionJSON.fulfilled]: (state, action) => {

        },
        [SystemWorkflowAddUpdateDefinitionJSON.rejected]: (state, action) => {

        },

        [SystemWorkflowControlsJSON.pending]: (state, action) => {
            state.workflowLoader = true;
        },
        [SystemWorkflowControlsJSON.fulfilled]: (state, action) => {
            state.workflowLoader = false;
        },
        [SystemWorkflowControlsJSON.rejected]: (state, action) => {
            state.workflowLoader = false;
        },

        [SystemWorkflowAddUpdateControlsJSON.pending]: (state, action) => {

        },
        [SystemWorkflowAddUpdateControlsJSON.fulfilled]: (state, action) => {

        },
        [SystemWorkflowAddUpdateControlsJSON.rejected]: (state, action) => {

        },

        [SystemWorkflowSectionsJSON.pending]: (state, action) => {
            state.workflowLoader = true;
        },
        [SystemWorkflowSectionsJSON.fulfilled]: (state, action) => {
            state.workflowLoader = false;
        },
        [SystemWorkflowSectionsJSON.rejected]: (state, action) => {
            state.workflowLoader = false;
        },

        [SystemWorkflowAddUpdateSectionsJSON.pending]: (state, action) => {

        },
        [SystemWorkflowAddUpdateSectionsJSON.fulfilled]: (state, action) => {

        },
        [SystemWorkflowAddUpdateSectionsJSON.rejected]: (state, action) => {

        },

        [SystemWorkflowStepsJSON.pending]: (state, action) => {
            state.workflowLoader = true;
        },
        [SystemWorkflowStepsJSON.fulfilled]: (state, action) => {
            state.workflowLoader = false;
        },
        [SystemWorkflowStepsJSON.rejected]: (state, action) => {
            state.workflowLoader = false;
        },

        [SystemWorkflowAddUpdateStepsJSON.pending]: (state, action) => {

        },
        [SystemWorkflowAddUpdateStepsJSON.fulfilled]: (state, action) => {

        },
        [SystemWorkflowAddUpdateStepsJSON.rejected]: (state, action) => {

        }
    }
})
export const { setLanguageCollection } = AdminSystemSlice.actions
export default AdminSystemSlice.reducer